const initialState = {
  isAuth: false,
  apiLoading: false,
  token: null,
  user: null,
  role: null,
  headerTitle: "",
  isReportLoading: false,
  menuList: null,
  lineImg: null,
  refresh: true,
  urlCode: '',
  andonStatus: 'Andon Green',
  dashboardPageName: '',
  isMenuCollapsed: false,
  andonData: null
};

export default function rootReducer(state = initialState, action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return {
        ...initialState,
        isAuth: true,
        token: action.payload["token"],
        user: action.payload["user"],
        role: action.payload["role"],
        menuList: action.payload["menu"],
        andonStatus: 'Andon Green'
      };
    case "LOGOUT":
      return {
        ...initialState,
        isAuth: false,
        token: null,
        user: null,
        role: null,
      };
    case "SET_HEADER_TITLE":
      return { ...initialState, headerTitle: action.payload["title"] };
    case "SET_REPORT_LOADING":
      return { ...state, isReportLoading: action.payload["loading"] };
    case "SET_SIDEBAR":
      return { ...initialState, menuList: action.payload };
    case "SET_LINE_IMG":
      return { ...state, lineImg: action.payload };
    case "REFRESH_IMG_LINEDASH":
      return { ...state, refresh: !state.refresh };
    case "andonStatus":
      return { ...state, andonStatus: action.payload.andonColor, andonData: action.payload.andonData };
    case "pageName":
      return { ...state, dashboardPageName: action.payload };
    case "urlCode":
      return { ...state, urlCode: action.payload };
    case "toggleMenu":
      return {...state, isMenuCollapsed: action.payload};
    case "apiLoading":
      return {...state, apiLoading: action.payload};
    default:
      return state;
  }
}
